// extracted by mini-css-extract-plugin
export default {"monthTitle":"CalendarView_monthTitle__GfFBB"};